import React from "react";
import {Button, Grid, TextField, Typography} from "@mui/material";
import {Field, FieldProps, FormikProps} from "formik";
import {useTranslation} from "react-i18next";
import {DictionaryObject} from "../../../../../../types/dictionary";
import {ThousandsSeparator} from "../../../../../../common/NumberFormat";
import {NewPlanRubricForm, RubricItem as RubricItemType} from "../../../../../../types/newPlanItem";
import {OptionData} from "../../../../../../common/AutocompleteServer";
import {dictionaryService} from "../../../../../../api/services/dictionary.service";
import AutocompleteField from "../../../../../../common/AutocompleteField";

export const RubricItem = ({
                               onProductModalOpen, frops, disabled = false
                           }: {
    onProductModalOpen: () => void;
    frops: FormikProps<NewPlanRubricForm>,
    disabled?: boolean,
}) => {
    const {values, setFieldValue} = frops;
    const {productType, item} = values;
    const {productCode} = item;
    const {t} = useTranslation();

    // const unit = useDictionary(
    //     Unit,
    //     (type) => ({value: type, labelЦ: t(`unit.${type}`)}),
    //     {value: Unit.sht, label: t("unit.sht")}
    // );

    const selected = {unit: null};

    // React.useEffect(() => {
    //     setFieldValue(`item.unit`, unit.selected, false)
    //     console.log('item.unit', values)
    // }, [unit.selected, values.productType]);

    return (
        <Grid container sx={{mt: 1}}>
            <ItemHeader
                item={values.item} selected={selected}/>

            <Grid item container columnSpacing={3} rowSpacing={1} sx={{mt: 1}}>
                {(productType.value === "custom")
                    ? <ItemCodeNameDescr item={item} productType={productType}/>
                    : <>
                        <Grid item xs={12} sm={12} md={12} sx={{alignSelf: "center", mb: 2}} >
                            <Field name={`item.productCode`}>
                                {({field, form, meta}: FieldProps) => (
                                    <Grid>
                                        <Button disabled={disabled} color={meta.touched && meta.error ? "error" : "primary"}
                                                variant="contained" size="small"
                                                onClick={() => onProductModalOpen()}
                                        >
                                            {t("cabinet.new_plan_item.modals.product.choose_product_code")}
                                        </Button>

                                        {(meta.touched && meta.error) &&
                                            <Typography
                                                color="#d32f2f" fontSize="0.6428571428571428rem"
                                                mt="4px" mx="14px" mb="0"
                                            >
                                                {meta.error}
                                            </Typography>
                                        }
                                    </Grid>
                                )}
                            </Field>
                        </Grid>
                        <ItemCodeNameDescr item={item} productType={productType} disabled={disabled}/>
                    </>
                }
            </Grid>

            <Grid item container columnSpacing={3} rowSpacing={1} sx={{mt: 1}}>
                <Grid item xs={12} sm={6} md={4}>
                    <Field name={`item.price`}>
                        {({field, form, meta}: FieldProps) => (
                            <TextField {...field}
                                       fullWidth color="primary" size="small"
                                       label={t("cabinet.new_plan_item.fields.rubric.price")}
                                       error={!!(meta.touched && meta.error)}
                                       helperText={meta.touched && meta.error}
                                       onBlur={() => {
                                           if (+field.value === 0) form.setFieldValue(`item.price`, "");
                                       }}
                                       InputProps={{inputComponent: ThousandsSeparator, readOnly: disabled}}
                            />
                        )}
                    </Field>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField additionalParams={{'lang': 'ru', "enstruCode": productCode}}
                                       fetchOptions={(query, page, size, additionalParams) =>
                                           dictionaryService.searchMkei(query, page, size, additionalParams!.enstruCode, additionalParams!.lang)}
                                       label={t("cabinet.new_plan_item.dictionary.unit")} name={"item.unit"} disabled={disabled}/>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Field name={`item.amount`}>
                        {({field, form, meta}: FieldProps) => (
                            <TextField {...field}
                                       fullWidth color="primary" size="small"
                                       label={t("cabinet.new_plan_item.fields.rubric.amount")}
                                       error={!!(meta.touched && meta.error)}
                                       helperText={meta.touched && meta.error}
                                       onBlur={() => {
                                           if (+field.value === 0) form.setFieldValue(`item.amount`, "");
                                       }}
                                       InputProps={{inputComponent: ThousandsSeparator, readOnly: disabled}}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>
        </Grid>
    )
}

const ItemHeader = ({
                        item, selected, disabled = false
                    }: {
    item: RubricItemType;
    selected: { unit: OptionData | null }, disabled?: boolean,
}) => {
    const {t} = useTranslation();
    const {productCode, price, amount} = item;
    const notEmptyCondition = [productCode, price, amount]
        .some(value => value);

    return (
        <Grid container justifyContent="space-between">

            <React.Fragment>
                <Grid item style={{alignSelf: "center"}}>
                    <b>{t("cabinet.new_plan_item.rubric.position")}</b>
                </Grid>
            </React.Fragment>
        </Grid>
    )
}

const ItemCodeNameDescr = ({
                               item, productType, disabled = false
                           }: {
    item: RubricItemType;
    productType: DictionaryObject;
    disabled?: boolean,
}) => {
    const {t} = useTranslation();
    const {productCode} = item;
    // const readOnlyCondition = false//productType.value !== "custom";

    return (
        <React.Fragment>
            <Grid item xs={12} sm={6} md={4}>
                <Field name={`item.productCode`}>
                    {({field, form, meta}: FieldProps) => (
                        <TextField {...field}
                                   fullWidth color="primary" type="text" size="small"
                                   label={productCode
                                       ? t("cabinet.new_plan_item.fields.rubric.productCode")
                                       : t("cabinet.new_plan_item.rubric.write_custom_product_code")
                                   }
                                   InputProps={{readOnly: disabled}}
                                   error={!!(meta.touched && meta.error)}
                                   helperText={meta.touched && meta.error}
                        />
                    )}
                </Field>
            </Grid>

            <Grid item xs={12} sm={6} md={8}>
                <Field name={`item.productName`}>
                    {({field, form, meta}: FieldProps) => (
                        <TextField {...field}
                                   fullWidth color="primary" type="text" size="small"
                                   label={t("cabinet.new_plan_item.fields.rubric.productName")}
                                   InputProps={{readOnly: disabled}}
                                   error={!!(meta.touched && meta.error)}
                                   helperText={meta.touched && meta.error}
                        />
                    )}
                </Field>
            </Grid>
            <Grid item xs={12} sm={8} md={12} sx={{my: 2}}>
                <Field name={`item.productBrief`}>
                    {({field, form, meta}: FieldProps) => (
                        <TextField {...field} multiline rows={4}
                                   fullWidth color="primary" type="text" size="small"
                                   label={t("cabinet.new_plan_item.fields.rubric.productBrief")}
                                   InputProps={{readOnly: disabled}}
                                   error={!!(meta.touched && meta.error)}
                                   helperText={meta.touched && meta.error}

                        />
                    )}
                </Field>
            </Grid>
        </React.Fragment>
    )
}
